import React from 'react';
import { CheckCircle } from 'lucide-react';

const Input = ({
  type = 'text',
  placeholder,
  value,
  onChange,
  onBlur,
  className = '',
  showCheck = true,
  hasError = false,
}) => {
  return (
    <div className="relative group">
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={`
          w-full px-4 py-3 bg-white border-2 rounded-lg
          focus:ring-2 focus:outline-none
          text-gray-800 placeholder-gray-400 shadow-md
          transition-all
          ${hasError
            ? 'border-red-500 focus:ring-red-300 focus:border-red-500'
            : 'border-red-200 focus:ring-red-300 focus:border-red-400 group-hover:border-red-300'
          }
          ${className}
        `}
      />
      {showCheck && value && !hasError && (
        <div className="absolute right-3 top-1/2 -translate-y-1/2 text-green-500 pointer-events-none">
          <CheckCircle className="w-4 h-4" />
        </div>
      )}
    </div>
  );
};

export default Input;